import { FormGroup } from '@angular/forms';
import { RxFormBuilder } from '@rxweb/reactive-form-validators';

export class FormHelper {
    public rxFormBuilder: RxFormBuilder;

    constructor() {
        this.rxFormBuilder = new RxFormBuilder();
    }

    ExtractFormGroupFromModel(entity: any, instanceType: any): FormGroup {
        return <FormGroup>this.rxFormBuilder.formGroup<FormGroup>(instanceType, entity);
    }
}
